<template>
  <div class="main-content">
    <div class="card">
      <div class="card-body">
        <div class="row">
          <div class="col-md-12">
            <ValidationObserver
ref="formObserver"
v-slot="{ validate }"
>
              <b-form @submit.prevent="handleSubmit(validate)">
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="Central"
                      rules="required"
                    >
                      <label for="Central">
                        <span class="required">*</span> {{ $t("Central") }}:
                      </label>
                      <v-select
                        v-model="device.center_id"
                        :options="centers"
                        :reduce="(center) => center.id"
                        :label="'name'"
                        class="vselect"
                        :class="{ 'is-invalid': errors.length }"
                        @input="changetUnitsCenter"
                      />
                      <span class="invalid-feedback">{{ $t(errors[0]) }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="form-group col-md-6">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="Unit"
                      rules="required"
                    >
                      <label for="Unit">
                        <span class="required">*</span> {{ $t("Unit") }}:
                      </label>
                      <v-select
                        v-model="device.unit_id"
                        :options="filteredDeviceUnits"
                        :reduce="(unit) => unit.id"
                        :label="'name'"
                        class="vselect"
                        :class="{ 'is-invalid': errors.length }"
                      />
                      <span class="invalid-feedback">{{ $t(errors[0]) }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="form-group col-md-6">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="Supplier"
                      rules="required"
                    >
                      <label for="Supplier">
                        <span class="required">*</span> {{ $t("Supplier") }}:
                      </label>
                      <v-select
                        v-model="device.supplier_id"
                        :options="suppliers"
                        :reduce="(supplier) => supplier.id"
                        :label="'name'"
                        class="vselect"
                        :class="{ 'is-invalid': errors.length }"
                      />
                      <span class="invalid-feedback">{{ $t(errors[0]) }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="form-group col-md-6">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="Device Model"
                      rules="required"
                    >
                      <label for="Devices-Model">
                        <span class="required">*</span>
                        {{ $t("Devices Model") }}:
                      </label>
                      <v-select
                        v-model="device.device_model_id"
                        :options="filteredDeviceModels"
                        :reduce="(deviceModel) => deviceModel.id"
                        :label="'name'"
                        class="vselect"
                        :class="{ 'is-invalid': errors.length }"
                      />
                      <span class="invalid-feedback">{{ $t(errors[0]) }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="form-group col-md-6">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="Device Type"
                      rules=""
                    >
                      <label for="Device-Type">
                        {{ $t("Device Type") }}:
                      </label>
                      <v-select
                        v-model="device.device_type_id"
                        :options="deviceTypes"
                        :reduce="(deviceType) => deviceType.id"
                        :label="'name'"
                        class="vselect"
                        :class="{ 'is-invalid': errors.length }"
                      />
                      <span class="invalid-feedback">{{ $t(errors[0]) }}</span>
                    </ValidationProvider>
                  </div>
                  <div class="form-group input-group-sm col-md-6">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="IMEI"
                      rules=""
                    >
                      <label for="operator"> {{ $t("IMEI") }}: </label>
                      <b-form-input
                        id="imei"
                        v-model="device.imei"
                        type="text"
                        :state="errors.length ? false : null"
                        placeholder=""
                      />
                      <b-form-invalid-feedback>{{
                        $t(errors[0])
                      }}</b-form-invalid-feedback>
                    </ValidationProvider>
                  </div>

                  <div v-if="!isCamera" class="form-group input-group-sm col-md-6">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="MAC Address"
                      rules="mac_address"
                    >
                      <label for="mac_address">
                        {{ $t("MAC Address") }}:
                      </label>
                        <b-form-input
                          id="mac_address"
                          v-model="device.mac_address"
                          type="text"
                          maxlength="17"
                          pattern="^([0-9A-Fa-f]{2}:){5}[0-9A-Fa-f]{2}$"
                          :state="errors.length ? false : null"
                          placeholder="AA:BB:CC:DD:EE:FF"
                          @input="onMacInput"
                          @blur="normalizeMacAddress"
                      />
                      <b-form-invalid-feedback>{{
                        $t(errors[0])
                      }}</b-form-invalid-feedback>
                    </ValidationProvider>
                  </div>
                  <div class="form-group col-md-6">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="Chip"
                      rules=""
                    >
                      <label for="Chip"> {{ $t("Chip") }}: </label>
                      <v-select
                        v-model="device.chip_id"
                        :options="chips"
                        :reduce="(chip) => chip.id"
                        :label="'iccid'"
                        class="vselect"
                        :class="{ 'is-invalid': errors.length }"
                      />
                      <b-form-invalid-feedback>{{
                        $t(errors[0])
                      }}</b-form-invalid-feedback>
                    </ValidationProvider>
                  </div>
                  <div class="form-group input-group-sm col-md-4">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="Firmware"
                      rules=""
                    >
                      <label for="Firmware"> {{ $t("Firmware") }}: </label>
                      <b-form-input
                        id="firmware"
                        v-model="device.firmware"
                        type="text"
                        :state="errors.length ? false : null"
                        placeholder=""
                      />
                      <b-form-invalid-feedback>{{
                        $t(errors[0])
                      }}</b-form-invalid-feedback>
                    </ValidationProvider>
                  </div>
                  <div class="form-group input-group-sm col-md-4">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="Serial Number"
                    >
                      <label for="SerialNumber">
                        {{ $t("Serial Number") }}:
                      </label>
                      <b-form-input
                        id="serial_number"
                        v-model="device.serial_number"
                        type="text"
                        :state="errors.length ? false : null"
                        placeholder=""
                      />
                      <b-form-invalid-feedback>{{
                        $t(errors[0])
                      }}</b-form-invalid-feedback>
                    </ValidationProvider>
                  </div>
                  <div class="form-group input-group-sm col-md-4">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="Acquisition Date"
                      rules="date_format"
                    >
                      <label for="Acquisition">
                        {{ $t("acquisition date") }}:
                      </label>
                      <b-form-input
                        id="acquisition_date"
                        v-model="device.acquisition_date"
                        type="date"
                        :state="errors.length ? false : null"
                        placeholder=""
                      />
                      <b-form-invalid-feedback>{{
                        $t(errors[0])
                      }}</b-form-invalid-feedback>
                    </ValidationProvider>
                  </div>
                  <div class="form-group input-group-sm col-md-4">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="Pulsus Device ID"
                    >
                      <label for="pulsus_device_id">
                        {{ $t("Pulsus Device ID") }}:
                      </label>
                      <b-form-input
                        id="pulsus_device_id"
                        v-model="device.pulsus_device_id"
                        type="text"
                        :state="errors.length ? false : null"
                        placeholder=""
                      />
                      <b-form-invalid-feedback>{{
                        $t(errors[0])
                      }}</b-form-invalid-feedback>
                    </ValidationProvider>
                  </div>
                  <div class="form-group input-group-sm col-md-12">
                    <ValidationProvider
                      v-slot="{ errors }"
                      name="Description"
                      rules="required"
                    >
                      <label for="Description">
                        <span class="required">*</span> {{ $t("Description") }}:
                      </label>
                      <b-form-input
                        id="description"
                        v-model="device.description"
                        type="text"
                        :state="errors.length ? false : null"
                        placeholder=""
                      />
                      <b-form-invalid-feedback>{{
                        $t(errors[0])
                      }}</b-form-invalid-feedback>
                    </ValidationProvider>
                  </div>
                </div>

                <div v-if="isCamera" class="camera-section mt-1">
                  <h5 class="camera-section__title">
                    <feather-icon icon="VideoIcon" size="18" /> {{ $t('Câmera') }}
                    <span
                        v-if="cameraOnline !== null"
                        class="camera-section__status"
                        :class="cameraOnline ? 'camera-section__status--online' : 'camera-section__status--offline'"
                    >● {{ cameraOnline ? $t('online') : $t('offline') }}</span>
                  </h5>

                  <div class="form-row">
                    <div class="form-group input-group-sm col-md-4">
                      <ValidationProvider
                        v-slot="{ errors }"
                        name="ID do terminal"
                        :rules="{ required: true, regex: /^\d{1,20}$/ }"
                      >
                        <label for="hikvision_device_id">
                          <span class="required">*</span> {{ $t('ID do terminal (JT808)') }}:
                        </label>
                        <b-form-input
                          id="hikvision_device_id"
                          v-model="device.hikvision_device_id"
                          type="text"
                          inputmode="numeric"
                          :state="errors.length ? false : null"
                          placeholder="016173783398"
                        />
                        <b-form-invalid-feedback>{{ $t('Só números, até 20 dígitos (o "Número do cartão SIM" da Plataforma JT na câmera)') }}</b-form-invalid-feedback>
                      </ValidationProvider>
                    </div>
                  </div>

                  <h6>{{ $t('Nome dos canais') }}</h6>
                  <div class="form-row">
                    <div v-for="channel in channels" :key="'name-' + channel" class="form-group input-group-sm col">
                      <label :for="'channel-name-' + channel">{{ $t('Channel') }} {{ channel }}:</label>
                      <b-form-input
                        :id="'channel-name-' + channel"
                        v-model="cameraSettings.channel_names[channel]"
                        maxlength="30"
                        :placeholder="$t('ex.: Frente')"
                      />
                    </div>
                  </div>

                  <h6 class="mt-1">{{ $t('Camera Access Lock') }}</h6>
                  <p class="text-muted small mb-1">
                    {{ $t('Select a user to require login before opening the channel (leave blank to require none).') }}
                  </p>
                  <div class="form-row">
                    <div v-for="channel in channels" :key="'lock-' + channel" class="form-group col-md-4">
                      <label :for="'camera-lock-' + channel">{{ $t('Channel') }} {{ channel }}:</label>
                      <v-select
                          :id="'camera-lock-' + channel"
                          v-model="cameraLocks[channel]"
                          :options="userOptions"
                          :reduce="(user) => user.id"
                          :label="'name'"
                          :placeholder="$t('None')"
                          class="vselect"
                      />
                    </div>
                  </div>

                </div>

                <span class="required_fields">
                  <span class="required">*</span>
                  <strong> {{ $t("Required Fields") }}</strong>
                </span>
                <div class="block text-right">
                  <b-button
                    variant="outline-secondary"
                    class="btn btn-back"
                    @click="$router.go(-1)"
                  >
                    <i class="fa fa-arrow-left" /> {{ $t("To Go Back") }}
                  </b-button>

                  <b-button
type="submit"
variant="primary"
class="ml-1"
>
                    {{ $t("Save") }}
                    <i class="fa fa-save" />
                  </b-button>
                </div>
              </b-form>
            </ValidationObserver>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ValidationObserver, ValidationProvider, extend } from 'vee-validate'
import { required, regex } from 'vee-validate/dist/rules'
import {
  BForm,
  BFormGroup,
  BFormInput,
  BFormInvalidFeedback,
  BButton,
} from 'bootstrap-vue'
import vSelect from 'vue-select'
import axios from 'axios'

extend('required', required)
extend('regex', regex)

function emptyCameraSettings() {
  return {
    channel_names: { 1: '', 2: '', 3: '', 4: '', 5: '' },
  }
}
extend('date_format', {
  validate: value => {
    const regex = /^\d{4}-\d{2}-\d{2}$/
    return regex.test(value)
  },
  message: 'The {_field_} field must be in the format YYYY-MM-DD',
})

extend('mac_address', {
  validate: value => {
    if (!value) return true
    return /^([0-9A-Fa-f]{2}:){5}[0-9A-Fa-f]{2}$/.test(value)
  },
  message: 'MAC Address deve estar no formato AA:BB:CC:DD:EE:FF',
})

export default {
  components: {
    ValidationObserver,
    ValidationProvider,
    BForm,
    BFormGroup,
    BFormInput,
    BFormInvalidFeedback,
    BButton,
    vSelect,
  },
  data() {
    return {
      device: {
        center_id: '',
        unit_id: '',
        supplier_id: '',
        device_model_id: '',
        device_type_id: '',
        chip_id: '',
        imei: '',
        mac_address: '',
        firmware: '',
        serial_number: '',
        acquisition_date: '',
        description: '',
        hikvision_device_id: '',
      },
      suppliers: [],
      centers: [],
      units: [],
      deviceModels: [],
      deviceTypes: [],
      chips: [],
      users: [],
      cameraLocks: { 1: null, 2: null, 3: null, 4: null, 5: null },
      channels: [1, 2, 3, 4, 5],
      cameraSettings: emptyCameraSettings(),
      cameraOnline: null,
      errors: undefined,
    }
  },
  computed: {
    // o tipo "Câmera" tem id diferente em cada ambiente: a referência é o nome
    isCamera() {
      const type = this.deviceTypes.find(t => t.name === 'Câmera')
      return !!type && type.id === this.device.device_type_id
    },
    userOptions() {
      return this.users.map(user => ({ id: user.id, name: `${user.name} (${user.email})` }))
    },
    filteredDeviceUnits() {
      return !this.device.center_id
        ? []
        : this.units.filter(
          models => models.center_id === this.device.center_id,
        )
    },
    filteredDeviceModels() {
      return !this.device.supplier_id
        ? []
        : this.deviceModels.filter(
          models => models.supplier_id === this.device.supplier_id,
        )
    },
  },
  mounted() {
    const { id } = this.$route.params
    if (id) {
      this.getDevice(id)
      this.getCameraLocks(id)
      this.getCameraSettings(id)
    }
    this.getSuppliers()
    this.getDeviceModels()
    this.getDeviceTypes()
    this.getCenters()
    this.getChips()
    this.getUsers()
  },
  methods: {
    async handleSubmit(validate) {
      const isValid = await validate()
      if (isValid) {
        this.save()
      }
    },
    changetUnitsCenter(center_id) {
      this.device.unit_id = ''
      this.getUnitsCenter(center_id)
    },
    normalizeMacAddress() {
      const bruto = (this.device.mac_address || '').trim()
      if (!bruto) {
        this.device.mac_address = ''
        return
      }
      const hex = bruto.replace(/[\s:.-]+/g, '')
      if (/^[0-9A-Fa-f]{12}$/.test(hex)) {
        this.device.mac_address = hex.toUpperCase().match(/.{2}/g).join(':')
      }
    },
    onMacInput(e) {
      // keep only hex chars, limit to 12, uppercase, insert ':' every 2 chars
      const raw = (e && e.target && e.target.value) || this.device.mac_address || ''
      const hex = raw.replace(/[^0-9a-fA-F]/g, '').slice(0, 12).toUpperCase()
      const parts = hex.match(/.{1,2}/g) || []
      this.device.mac_address = parts.join(':')
    },
    save() {
      let api = `${this.$store.state.api}devices`
      const isEdit = !!this.device.id
      if (isEdit) {
        this.device._method = 'PUT'
        api += `/${this.device.id}`
      }
      axios
        .post(api, this.device)
        .then(async response => {
          const deviceId = isEdit ? this.device.id : response.data && response.data.id
          if (this.isCamera && deviceId) {
            try {
              await this.saveCameraLocks(deviceId)
              await this.saveCameraSettings(deviceId)
            } catch (error) {
              this.$error(error)
              return
            }
          }
          this.$message(
            this.$t('Success'),
            this.$t('Information saved successfully'),
            'success',
          )
          this.$router.push('/devices')
        })
        .catch(error => {
          this.$error(error)
        })
    },
    getDevice(id) {
      const api = `${this.$store.state.api}devices/${id}`
      axios
        .get(api)
        .then(response => {
          const payload = response && response.data
            ? response.data.data || response.data
            : null
          const deviceObj = Array.isArray(payload) ? payload[0] : payload || {}
          this.device = deviceObj

          if (this.device && this.device.acquisition_date) {
            const v = this.device.acquisition_date
            if (typeof v === 'string') {
              const m = v.match(/^(\d{4}-\d{2}-\d{2})/)
              if (m) this.device.acquisition_date = m[1]
            } else if (v instanceof Date) {
              const y = v.getFullYear()
              const mm = String(v.getMonth() + 1).padStart(2, '0')
              const dd = String(v.getDate()).padStart(2, '0')
              this.device.acquisition_date = `${y}-${mm}-${dd}`
            }
          }

          if (this.device && this.device.center_id) this.getUnitsCenter(this.device.center_id)
          if (this.device && this.device.hikvision_device_id) this.getCameraStatus()
        })
        .catch(error => {
          this.$error(error)
        })
    },
    getCenters() {
      const api = `${this.$store.state.api}centers/`
      axios
        .get(api)
        .then(response => {
          this.centers = response.data.data
        })
        .catch(error => {
          this.$error(error)
        })
    },
    getUnitsCenter(center_id) {
      const api = `${this.$store.state.api}centers/unit/${center_id}`
      axios
        .get(api)
        .then(response => {
          this.units = response.data
        })
        .catch(error => {
          this.$error(error)
        })
    },
    getDeviceModels() {
      const api = `${this.$store.state.api}deviceModels`
      axios
        .get(api)
        .then(response => {
          this.deviceModels = response.data.data
        })
        .catch(error => {
          this.$error(error)
        })
    },
    getDeviceTypes() {
      const api = `${this.$store.state.api}deviceTypes`
      axios
        .get(api)
        .then(response => {
          this.deviceTypes = response.data.data
        })
        .catch(error => {
          this.$error(error)
        })
    },
    getSuppliers() {
      const api = `${this.$store.state.api}suppliers`
      axios
        .get(api)
        .then(response => {
          this.suppliers = response.data.data
        })
        .catch(error => {
          this.$error(error)
        })
    },
    getChips() {
      const api = `${this.$store.state.api}chips`
      axios
        .get(api)
        .then(response => {
          this.chips = response.data.data
        })
        .catch(error => {
          this.$error(error)
        })
    },
    getUsers() {
      const api = `${this.$store.state.api}users`
      axios
        .get(api)
        .then(response => {
          this.users = response.data.data
        })
        .catch(error => {
          this.$error(error)
        })
    },
    getCameraLocks(deviceId) {
      const api = `${this.$store.state.api}devices/${deviceId}/camera-locks`
      axios
        .get(api)
        .then(response => {
          const locks = (response.data && response.data.data) || []
          const map = { 1: null, 2: null, 3: null, 4: null, 5: null }
          locks.forEach(lock => { map[lock.channel] = lock.required_user_id })
          this.cameraLocks = map
        })
        .catch(error => {
          this.$error(error)
        })
    },
    getCameraSettings(id) {
      axios
        .get(`${this.$store.state.api}devices/${id}/camera-settings`)
        .then(response => {
          const data = (response.data && response.data.data) || {}
          this.cameraSettings = {
            ...emptyCameraSettings(),
            ...data,
            channel_names: { ...emptyCameraSettings().channel_names, ...(data.channel_names || {}) },
          }
        })
        .catch(error => this.$error(error))
    },
    saveCameraSettings(deviceId) {
      return axios.put(`${this.$store.state.api}devices/${deviceId}/camera-settings`, {
        channel_names: this.cameraSettings.channel_names,
      })
    },
    getCameraStatus() {
      axios
        .get(`${this.$store.state.api}cameras/status`)
        .then(response => {
          const body = response.data || {}
          const terminal = String(this.device.hikvision_device_id || '').replace(/^0+/, '')
          this.cameraOnline = body.available && terminal ? !!(body.data || {})[terminal] : null
        })
        .catch(() => {
          this.cameraOnline = null
        })
    },
    saveCameraLocks(deviceId) {
      const api = `${this.$store.state.api}devices/${deviceId}/camera-locks`
      const locks = Object.keys(this.cameraLocks).map(channel => ({
        channel: Number(channel),
        required_user_id: this.cameraLocks[channel] || null,
      }))
      return axios.put(api, { locks })
    },
  },
}
</script>

<style scoped>
.required {
  color: red !important;
}

.camera-section {
  padding: 1rem 1.25rem;
  border: 1px solid #ebe9f1;
  border-radius: 0.428rem;
  background: #fafafc;
  margin-bottom: 1rem;
}

.camera-section__title {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  margin-bottom: 1rem;
}

.camera-section__status {
  margin-left: auto;
  font-size: 0.85rem;
  font-weight: 600;
}

.camera-section__status--online {
  color: #28c76f;
}

.camera-section__status--offline {
  color: #b9b9c3;
}

</style>
